// 全局的过滤器
import Vue from 'vue'
import moment from 'moment'

Vue.filter('dataFormat', (input, pattern = 'YYYY-MM-DD') => {
  return moment(input).format(pattern)
})



// WEBPACK FOOTER //
// ./src/utils/filter.js